import { render, staticRenderFns } from "./MetroImport.vue?vue&type=template&id=50b53641&scoped=true"
import script from "./MetroImport.vue?vue&type=script&lang=js"
export * from "./MetroImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b53641",
  null
  
)

export default component.exports